<template>
  <div :class="[baseCss]" ref="time-picker-field">
    <text-field readonly @focus="hidden = false" v-model="value" :label-color="labelColor" :label-color-lightness="labelColorLightness" :label="label" :disabled="disabled" :icon-provider="iconProvider" :icon-left="iconLeft" :icon-right="iconRight" :color="color" :color-lightness="colorLightness" :class="['mb-2']" />
    <container :class="['relative']">
      <transition name="fade">
        <time-picker @input="onInput" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" :font-size="fontSize" :icon-size="iconSize" :pad-zero="padZero" :buttons="spinButtons" :dense="dense" :elevation="elevation" :color="color" :icon-up="iconUp" :icon-down="iconDown" :icon-provider="iconProvider" :hour-cycle="hourCycle" :initial-state="initialState" :separator="separator" :segments="segments" :color-lightness="colorLightness" :style="{zIndex}" :class="['absolute', hidden ? ['clip-0', 'opacity-0'] : null]" />
      </transition>
    </container>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'TimePickerField',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      hidden: true,
      value: null,
      baseCss: this.componentBaseCss('time-picker-field', [])
    }
  },
  props: {
    bgColor: {
      type: String
    },
    bgColorLightness: {
      type: Number
    },
    padZero: {
      type: Boolean,
      default: true
    },
    fontSize: {
      type: Number,
      default: 1.75
    },
    iconSize: {
      type: Number,
      default: 1.75
    },
    iconUp: {
      type: String,
      default: 'chevron-up'
    },
    iconDown: {
      type: String,
      default: 'chevron-down'
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    spinButtons: {
      type: Boolean,
      default: true
    },
    color: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    iconLeft: {
      type: String
    },
    label: {
      type: String
    },
    dense: {
      type: Boolean
    },
    iconRight: {
      type: String
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    labelColor: {
      type: String
    },
    labelColorLightness: {
      type: Number
    },
    hourCycle: {
      type: String,
      default: 'h23',
      validator: value => {
        return [
          'h11',
          'h12',
          'h23',
          'h24'
        ].includes(value)
      }
    },
    initialState: {
      type: Object,
      default: () => {
        return {
          hours: 0,
          minutes: 0,
          seconds: 0,
          'am/pm': 'am'
        }
      }
    },
    separator: {
      type: String,
      default: ':'
    },
    segments: {
      type: Array,
      default: () => {
        return [
          'hours',
          'minutes',
          'seconds',
          'am/pm'
        ]
      }
    }
  },
  created () {
    document.addEventListener('click', this.documentClick)
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick)
  },
  methods: {
    documentClick (e) {
      let el = this.$refs['time-picker-field']
      let target = e.target
      if (el !== target && !el.contains(target)) {
        this.hidden = true
      }
    },
    onInput ($event) {
      let value = []
      const timestamp = new Date()
      const hours = $event['hours']
      const minutes = $event['minutes']
      const seconds = $event['seconds']
      const amPm = $event['am/pm']
      if (hours) {
        value.push(hours)
      }
      if (minutes) {
        value.push(minutes)
      }
      if (seconds) {
        value.push(seconds)
      }
      value = `${value.join(this.separator)}${amPm ? ' ' + amPm : ''}`
      this.value = value
      timestamp.setHours(hours || 0, minutes || 0, seconds || 0)
      this.$emit('input', {value, timestamp, time: $event})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/time-picker-field/time-picker-field.vue